export enum SideDrawerRoutes {
  root = 'sidedrawers',
}
